import React from 'react';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

const Container = styled.div`
  background: #EBEBEB;
  margin-top: 30px;
`;

const SectionTitle = styled.span`
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #F1A857;
  letter-spacing: 0;
`

const Block = styled.div`
  width: 100%;
  display: flex;
  padding: 14px 16px 0;
  flex-wrap: wrap;
  font-size: 14px;
  box-sizing: border-box;
  font-size: 14px;
  color: #616161;
  letter-spacing: 0;
  line-height: 24px;
  border-top: 1px solid #DEDEDE;
  &:first-child {
    border-top: 0;
  }
  a {
    border: 3px solid #F1A857;
    border-radius: 3px;
    height: 55px;
    display: block;
    width: 100%;
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s;
    margin-bottom: 14px;
    &:hover {
      background: #F1A857;
      .icone {
        border-color: #E0933D;
      }
      .texto {
        color: #fff;
      }
    }
    .icone {
      border-right: 1px solid #F1A857;
      width: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin-right: 20px;
      i {
        height: 30px;
        width: 30px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .texto {
      align-items: center;
      display: flex;
      font-size: 14px;
      color: #6A6A6A;
      letter-spacing: 0.31px;
    }
  }
`

const BoxConteudo = ({box_conteudo}) => {
  return (
    <Container>
      {
        box_conteudo.map((item, index) => {
          return (
            <Block key={ index }>
              <SectionTitle>{ item.nome1 }</SectionTitle>
              { RichText.render(item.texto) }
              {
                item.link.url && (
                  <a href={ item.link.url } target="_blank" rel="noopener noreferrer">
                    <span className="icone">
                      <i style={ { backgroundImage: `url(${item.icone_botao.url})`}}></i>
                    </span>
                    <span className="texto">
                      { item.texto_botao }
                    </span>
                  </a>
                )
              }
            </Block>
          )
        })
      }
    </Container>
  );
}

export default BoxConteudo;
